import { render, staticRenderFns } from "./CouponShowDialog.vue?vue&type=template&id=4144113a&scoped=true"
import script from "./CouponShowDialog.vue?vue&type=script&lang=js"
export * from "./CouponShowDialog.vue?vue&type=script&lang=js"
import style0 from "./CouponShowDialog.vue?vue&type=style&index=0&id=4144113a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4144113a",
  null
  
)

export default component.exports